import React, { useMemo } from 'react';

import Schedule from './schedule';

import { ScheduleOnClick, TimezoneDropdownOption } from '../types';
import { getSuggestedSchedules } from '../utils/get-suggested-schedules';

type IProps = {
  selectedTimezone: TimezoneDropdownOption;
  onClick: ScheduleOnClick;
  selectedSuggestion: string;
  initialSelectionFeedback: boolean;
};

const SuggestedSchedules: React.FC<IProps> = ({
  selectedTimezone,
  onClick,
  selectedSuggestion,
  initialSelectionFeedback,
}) => {
  const suggestedSchedules = useMemo(
    () => getSuggestedSchedules(selectedTimezone?.name || ''),
    [selectedTimezone],
  );

  return (
    <div className="schedule-reply-modal--content-wrapper suggested-schedules-wrapper">
      {suggestedSchedules?.map((schedule, index) => (
        <Schedule
          selectedSchedule={selectedSuggestion === schedule.id}
          schedule={schedule}
          onClick={onClick}
          initialSelectionFeedback={
            initialSelectionFeedback ? index === 0 : false
          }
        />
      ))}
    </div>
  );
};

export default SuggestedSchedules;
